import { render, staticRenderFns } from "./ActiveExercises.vue?vue&type=template&id=6b2a34d8&"
import script from "./ActiveExercises.vue?vue&type=script&lang=js&"
export * from "./ActiveExercises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports